import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import ErrorMessage from '../../../../../Components/Form/components/ErrorMessage';
import TopFieldContent from '../../../../../Components/Form/components/TopFieldContent';
import useFormName from '../../../../../Hooks/useFormName';
import InputWrapper from '../../../../../Components/Form/components/InputWrapper/InputWrapper';

export interface BaseFieldProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	placeholder?: string;
	portal?: boolean;
	disabled?: boolean;
	isWrapped?: boolean;
}

interface Props extends BaseFieldProps {
	children: React.ReactElement;
}

const BaseField: React.FC<Props> = ({
	name,
	label,
	isRequired,
	className,
	children,
	placeholder,
	portal,
	disabled,
	isWrapped,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();
	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName || '',
	});

	// @ts-ignore
	const errorMessage = (error?.message || error?.value?.message) ?? undefined;

	const component = (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			{React.cloneElement(children, {
				...children.props,
				value: field.value,
				onChange: field.onChange,
				portal: portal,
				error: error,
				placeholder: placeholder,
				disabled: disabled,
				hasError: Boolean(error?.message),
			})}
			{errorMessage && <ErrorMessage tx={errorMessage} />}
		</div>
	);

	if (isWrapped) {
		return <InputWrapper>{component}</InputWrapper>;
	}

	return component;
};

export default BaseField;
